import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { removeAll, removeAssured } from "./../Store/data/actions";
import { useDispatch } from "react-redux";
import { addRecommended } from "../Store/recommended/actions";
import DetailsTab from "./detailsTab";
import ModalRetakeAsessory from "../Components/modalRetakeAsessory";
import {
  cleanTablePdfVAS,
  cleanTablePdf,
  cleanTablePdfIG,
} from "../Store/secureInvestmentIncome/actions";
import { modalSteps } from "../Store/simulate/actions";

const TitleSecureInves = ({ dataState, investmentProfile }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.login.firstName);
  const username = user ? user.replace("undefined", "") : "";
  const [watchDetails, setWatchDetails] = useState(false);
  const [wipe, setWipe] = useState(true);
  const [showButton, setShowButton] = useState(true);
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const handleButtonClick = () => {
    history.push("/datos-asegurado");
  };

  const handleClear = () => {
    setOpenModalMessage(true);
  };

  const handleOpen = () => {
    setWatchDetails(false);
    setWipe(false);
    dispatch(addRecommended({}));
    setOpenModalMessage(false);
    dispatch(cleanTablePdfVAS());
    dispatch(cleanTablePdf());
    dispatch(cleanTablePdfIG());
  };

  const handleClose = () => {
    setOpenModalMessage(false);
  };

  useEffect(() => {
    if (
      watchDetails === false &&
      wipe === false &&
      Object.keys(dataState).length > 1
    ) {
      dispatch(removeAll());
    }
    if (
      watchDetails === false &&
      wipe === false &&
      Object.keys(dataState).length === 1
    ) {
      dispatch(removeAssured());
    } else {
    }
    if (!watchDetails && !wipe) {
      setShowButton(true);
    } else if (!watchDetails && wipe) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  }, [wipe, watchDetails]);

  useEffect(() => {
    if (Object.keys(dataState).length > 0 && wipe) {
      setWatchDetails(true);
    }
    if (Object.values(dataState)) {
      if (
        Object.keys(dataState).length > 0 &&
        Object.values(dataState)[0].names === undefined
      ) {
        setWatchDetails(false);
      }
    }
  }, [dataState, wipe]);

  useEffect(() => {
    dispatch(modalSteps(false));
  }, []);

  return (
    <div className="wrap">
      <div className="titleSecureInves">
        <div className="titleSecureInves__container">
          <div className="titleSecureInves__container__t1">
            ¡Hola, {username}!
          </div>
          <div className="titleSecureInves__container__t2">
            Estos son los productos disponibles
          </div>
        </div>
        {showButton && (
          <div className="titleSecureInves__container">
            <div className="vasForm__form__btn-container">
              <button onClick={handleButtonClick} className="btn is-medium">
                Nueva asesoría
              </button>
            </div>
          </div>
        )}
        {watchDetails && wipe && (
          <DetailsTab
            dataState={dataState}
            list={false}
            onClick={() => handleClear()}
            customerProfile={investmentProfile}
          />
        )}
        <ModalRetakeAsessory
          open={openModalMessage}
          setOpen={setOpenModalMessage}
          title="¿Estas seguro?"
          subtitleMessage="Al limpiar datos perderás las cotizaciones que generaste."
          messageAlert="Si quieres volver a cotizar deberás ingresar nuevamente el número de DNI de tu cliente; la plataforma solo guardará su perfil de inversión."
          firstButtonText="CANCELAR"
          secondButtonText="CONFIRMAR"
          firstButtonFunction={handleClose}
          secondButtonFunction={handleOpen}
        />
      </div>
    </div>
  );
};

export default TitleSecureInves;
